<div mat-dialog-content>
  <mat-form-field>
    <input matInput [(ngModel)]="store" placeholder="Enter Store Name">
  </mat-form-field>
</div>
<div class="action-panel text-right">
  <button mat-raised-button class="btn btn-primary m-left" color="primary" (click)="onSubmit()">Save</button>
  <button mat-raised-button class="btn m-left btn-light" color="warn" (click)="onNoClick()">Cancel</button>
</div>
